import React from 'react'
import { Route } from 'react-router-dom'

import PrivateRoute from '../../../components/PrivateRoute'
import { SuperAdminRoutes } from '../../../routes'

// Super-Admin routes
import Tenants from '../../Super-Admin/Tenants'
import TenantOwner from '../../Super-Admin/TenantOwner'
import Themes from '../../Super-Admin/Themes'
import Admins from '../../Super-Admin/Admins'
import AdminDetails from '../../Super-Admin/AdminDetails'
import TenantDetails from '../../Super-Admin/TenantDetails'
import Currencies from '../../Super-Admin/Currencies'
import CreateCurrencies from '../../Super-Admin/Currencies/components/CreateCurrencies'
import EditCurrency from '../../Super-Admin/Currencies/components/editCurrency'
import CreateTenantAdmin from '../../Super-Admin/TenantOwner/components/CreateTenantAdmin'
import Dashboard from '../../Super-Admin/Dashboard'
import EditTenant from '../../Super-Admin/EditTenant'
import EditTheme from '../../Super-Admin/Themes/EditTheme'
import CreateTheme from '../../Super-Admin/Themes/CreateTheme'
import Cms from '../../Super-Admin/CMS'
import Users from '../../Super-Admin/Users'
import UserDetails from '../../Super-Admin/UserDetails'
import CreateCredential from '../../Super-Admin/TenantDetails/components/CreateCredential'
import CMSDetail from '../../Super-Admin/CMS/components/CmsDetail'
import CasinoProviders from '../../Super-Admin/CasinoProviders'
import CasinoGames from '../../Super-Admin/CasinoGames'
import SuperAdminCasinoStudios from '../../Super-Admin/CasinoStudios'
import Countries from '../../Super-Admin/Countries'
import CreateSuperAdminUser from '../../Super-Admin/Admins/components/CreateSuperAdminUser'
import EditSuperAdminUser from '../../Super-Admin/Admins/components/EditSuperAdminUser'
import EditTenantAdmin from '../../Super-Admin/TenantOwner/components/EditTenantAdmin'
import TransactionsBanking from '../../Super-Admin/TransactionsBanking'
import Wallet from '../../../components/Sidebar/components/Wallet'
import Aggregators from '../../Super-Admin/Aggregators'
import CasinoCategory from '../../Super-Admin/CasinoCategory'
import CasinoSubCategory from '../../Super-Admin/CasinoSubCategory'
import RestrictedGames from '../../Super-Admin/RestrictedGames'
import RestrictedProviders from '../../Super-Admin/RestrictedProviders'
import RestrictProviderCountries from '../../Super-Admin/RestrictProviderCountries'
import RestrictGamesCountries from '../../Super-Admin/RestrictGamesCountries'
import CasinoTransactions from '../../Super-Admin/CasinoTransactions'
import CreateCMSNew from '../../Super-Admin/CMS/components/CreateCMSNew'
import EditCms from '../../Super-Admin/CMS/components/EditCms'
import FormFields from '../../Super-Admin/FormFields'
import CreateBonus from '../../Super-Admin/Bonus/components/CreateBonus'
import BonusManagement from '../../Super-Admin/Bonus'
import EditBonus from '../../Super-Admin/Bonus/components/EditBonus'
import KYCLabels from '../../Super-Admin/KYCLabels'
import CloneBonus from '../../Super-Admin/Bonus/components/CloneBonus'
import BonusDetail from '../../Super-Admin/Bonus/BonusDetail'
import WageringTemplate from '../../Super-Admin/WageringTemplate'
import WageringTeplateDetails from '../../Super-Admin/WageringTemplate/components/WageringTeplateDetails'
import EditWageringTemplate from '../../Super-Admin/WageringTemplate/components/EditWageringTemplate'
import CreateWageringTemplate from '../../Super-Admin/WageringTemplate/components/CreateWageringTemplate'
import ProfilePage from '../../../components/ProfilePage'
import LoyaltyPoints from '../../../components/LoyaltyPoints'
import EmailTemplate from '../../Super-Admin/EmailTemplate'
import EditEmailTemplate from '../../Super-Admin/EmailTemplate/editEmailTemplate'
import OwnerDetails from '../../Super-Admin/TenantOwner/components/OwnerDetails'
import Languages from '../../Super-Admin/Languages'
import ImageGallery from '../../Super-Admin/ImageGallery'
import BannerManagement from '../../Super-Admin/BannerManagement'
import LanguageManagement from '../../Super-Admin/Languages/components/LanguageManagement'
import LanguageWise from '../../../components/LanguageMgmt/components/LanguageWise'
import KeyWise from '../../../components/LanguageMgmt/components/KeyWise'
import AddLangauge from '../../../components/LanguageMgmt/components/AddLanguage'
import AddKeys from '../../../components/LanguageMgmt/components/AddKeys'
import CreateTenant from '../../Super-Admin/CreateTenant'
import CustomPayment from '../../../pages/Super-Admin/CustomPayment'
import EditProvider from '../../Super-Admin/CustomPayment/components/EditProvider'
import ReorderBonus from '../../../components/ReorderBonus'
import ReviewManagement from '../../Super-Admin/ReviewManagement'
import ManagersList from '../../Super-Admin/TenantOwner/components/ManagersList'
import BannedGames from '../../Super-Admin/BannedGames'
import CreateBannedGames from '../../Super-Admin/BannedGames/components/CreateBannedGames'
import EditBannedGames from '../../Super-Admin/BannedGames/components/EditBannedGames'
import BannedGamesDetails from '../../Super-Admin/BannedGames/components/BannedGamesDetails'
import CreateGroup from '../../../components/GroupManagement/components/CreateGroup'
import GroupManagement from '../../../components/GroupManagement'
import ProviderReorder from '../../Super-Admin/CustomPayment/components/ProviderReorder'
import Tournaments from '../../../components/Tournaments'
import CreateTournament from '../../../components/Tournaments/components/CreateTournament'
import EditBanners from '../../Super-Admin/BannerManagement/components/EditBanners'
import RGModule from '../../Super-Admin/RGModule'
import SetRGThresholds from '../../Super-Admin/RGModule/SetThresholds'
import SetAMLThresholds from '../../Super-Admin/AMLModule/setThresholds'
import AmlPlayerListing from '../../Super-Admin/AMLModule/playerListing'
import BannedUsers from '../../Super-Admin/BannedUsers'
import BannedPlayerSetting from '../../../components/BannedPlayerSetting'
import Hub88PrepaidList from '../../Super-Admin/Hub88PrepaidList'
import TenantCredentials from '../../Tenant/TenantCredentials'
import AddLicenseForm from '../../../components/LicenseManagement/AddLicenseForm'
import EditLicenseForm from '../../../components/LicenseManagement/EditLicenseForm'
import HomePageUIConfig from '../../Super-Admin/HomePageUIConfig'
import AccountPageUIConfig from '../../Super-Admin/AccountPageUIConfig'
import {
  PERMISSION_KEY
} from '../../../constants/permission'
const SuperAdminPages = () => {
  const {
    TENANT_MANAGEMENT,
    STAFF,
    CURRENCIES,
    LANGUAGES,
    CMS,
    GAMES,
    GAME_PROVIDERS,
    GAME_STUDIOS,
    COUNTRIES,
    GAME_AGGREGATORS,
    GAME_CATEGORIES,
    GAME_SUB_CATEGORIES,
    FINANCIAL_TRANSACTIONS,
    CASINO_TRANSACTIONS,
    REGISTRATION,
    BONUS,
    KYC_SETTINGS,
    BANNED_GAMES,
    WAGERING_TEMPLATE,
    EMAIL_TEMPLATE,
    LOYALTY_MANAGEMENT,
    IMAGE_GALLERY,
    BANNER_MANAGEMENT,
    TRANSLATIONS,
    CASHIER_METHODS,
    REVIEW_MANAGEMENT,
    GROUP_MANAGEMENT,
    TOURNAMENT,
    FLAGGED_PLAYERS,
    SELF_EXCLUDED_PLAYERS,
    BANNED_PLAYERS,
    BANNED_PLAYER_SETTING,
    SET_THRESHOLDS,
    ERROR_MANAGEMENT,
    OTHER_SETTINGS,
    AML_SET_THRESHOLDS,
    AML_FLAGGED_PLAYERS,
    PLAYERS,
    HOME_PAGE,
    ACCOUNT_PAGE
  } = PERMISSION_KEY

  return (
    <>
      <Route
        path={SuperAdminRoutes.Wallet}
        element={
          <PrivateRoute>
            <Wallet />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.TenantOwner}
        element={
          <PrivateRoute module={{ Tenant: 'R' }} permissionKey={TENANT_MANAGEMENT}>
            <TenantOwner />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.Tenants}
        element={
          <PrivateRoute module={{ Tenant: 'R' }} permissionKey={TENANT_MANAGEMENT}>
            <Tenants />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateTenant}
        element={
          <PrivateRoute module={{ Tenant: 'C' }} permissionKey={TENANT_MANAGEMENT}>
            <CreateTenant />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.TenantDetails}
        element={
          <PrivateRoute module={{ Tenant: 'R' }} permissionKey={TENANT_MANAGEMENT}>
            <TenantDetails />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Credentials}
        element={
          <PrivateRoute module={{ Settings: 'R' }} permissionKey={OTHER_SETTINGS}>
            <TenantCredentials />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Admins}
        element={
          <PrivateRoute module={{ Admins: 'R' }} permissionKey={STAFF}>
            <Admins />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AdminDetails}
        element={
          <PrivateRoute module={{ Admins: 'R' }} permissionKey={STAFF}>
            <AdminDetails />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Themes}
        element={
          <PrivateRoute module={{ Themes: 'R' }}>
            <Themes />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Currencies}
        element={
          <PrivateRoute module={{ Currencies: 'R' }} permissionKey={CURRENCIES}>
            <Currencies />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Languages}
        element={
          <PrivateRoute module={{ Language: 'R' }} permissionKey={LANGUAGES}>
            <Languages />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateTheme}
        element={
          <PrivateRoute module={{ Themes: 'C' }}>
            <CreateTheme />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CMSDetail}
        element={
          <PrivateRoute module={{ CMS: 'R' }} permissionKey={CMS}>
            <CMSDetail />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditTheme}
        element={
          <PrivateRoute module={{ Themes: 'U' }}>
            <EditTheme />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateCurrencies}
        element={
          <PrivateRoute module={{ Currencies: 'C' }} permissionKey={CURRENCIES}>
            <CreateCurrencies />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateTenantAdmin}
        element={
          <PrivateRoute module={{ Tenant: 'C' }} permissionKey={TENANT_MANAGEMENT}>
            <CreateTenantAdmin />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoGames}
        element={
          <PrivateRoute module={{ CasinoGame: 'R' }} permissionKey={GAMES}>
            <CasinoGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoStudios}
        element={
          <PrivateRoute module={{ CasinoStudio: 'R' }} permissionKey={GAME_STUDIOS}>
            <SuperAdminCasinoStudios />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CMS}
        element={
          <PrivateRoute module={{ CMS: 'R' }} permissionKey={CMS}>
            <Cms />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateCMS}
        element={
          <PrivateRoute module={{ CMS: 'C' }} permissionKey={CMS}>
            <CreateCMSNew />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BannedUsers}
        element={
          <PrivateRoute module={{ BannedPlayer: 'R' }} permissionKey={BANNED_PLAYERS}>
            <BannedUsers />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Users}
        element={
          <PrivateRoute module={{ Users: 'R' }} permissionKey={PLAYERS}>
            <Users />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.UserDetails}
        element={
          <PrivateRoute module={{ Users: 'R' }} permissionKey={PLAYERS}>
            <UserDetails />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditTenant}
        element={
          <PrivateRoute module={{ Tenant: 'U' }} permissionKey={TENANT_MANAGEMENT}>
            <EditTenant />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditCurrency}
        element={
          <PrivateRoute module={{ Currencies: 'U' }} permissionKey={CURRENCIES}>
            <EditCurrency />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Dashboard}
        element={
          <PrivateRoute isWithoutCard>
            <Dashboard />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Credential}
        element={
          <PrivateRoute module={{ TenantCredentials: 'C' }} permissionKey={TENANT_MANAGEMENT}>
            <CreateCredential />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoProviders}
        element={
          <PrivateRoute module={{ CasinoProvider: 'R' }} permissionKey={GAME_PROVIDERS}>
            <CasinoProviders />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Countries}
        element={
          <PrivateRoute module={{ RestrictedCountry: 'R' }} permissionKey={COUNTRIES}>
            <Countries />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateSuperAdminUser}
        element={
          <PrivateRoute module={{ Admins: 'C' }} permissionKey={STAFF}>
            <CreateSuperAdminUser />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditSuperAdminUser}
        element={
          <PrivateRoute module={{ Admins: 'U' }} permissionKey={STAFF}>
            <EditSuperAdminUser />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditTenantAdmin}
        element={
          <PrivateRoute module={{ Tenant: 'U' }} permissionKey={TENANT_MANAGEMENT}>
            <EditTenantAdmin />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.TransactionsBanking}
        element={
          <PrivateRoute module={{ Transactions: 'R' }} permissionKey={FINANCIAL_TRANSACTIONS}>
            <TransactionsBanking />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Aggregators}
        element={
          <PrivateRoute module={{ CasinoAggregator: 'R' }} permissionKey={GAME_AGGREGATORS}>
            <Aggregators />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoCategory}
        element={
          <PrivateRoute module={{ CasinoAllCategory: 'R' }} permissionKey={GAME_CATEGORIES}>
            <CasinoCategory />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoSubCategory}
        element={
          <PrivateRoute module={{ CasinoAllSubCategory: 'R' }} permissionKey={GAME_SUB_CATEGORIES}>
            <CasinoSubCategory />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.RestrictedGames}
        element={
          <PrivateRoute module={{ RestrictedCountry: 'U' }} permissionKey={COUNTRIES}>
            <RestrictedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.RestrictedProviders}
        element={
          <PrivateRoute module={{ RestrictedCountry: 'U' }} permissionKey={COUNTRIES}>
            <RestrictedProviders />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.RestrictedProviderCountries}
        element={
          <PrivateRoute module={{ CasinoProvider: 'U' }} permissionKey={GAME_PROVIDERS}>
            <RestrictProviderCountries />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.RestrictedGameCountries}
        element={
          <PrivateRoute module={{ CasinoGame: 'U' }} permissionKey={GAMES}>
            <RestrictGamesCountries />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ReviewManagement}
        element={
          <PrivateRoute module={{ Reviews: 'U' }} permissionKey={REVIEW_MANAGEMENT}>
            <ReviewManagement />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CasinoTransactions}
        element={
          <PrivateRoute module={{ CasinoTransaction: 'R' }} permissionKey={CASINO_TRANSACTIONS}>
            <CasinoTransactions />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditCMS}
        element={
          <PrivateRoute module={{ CMS: 'U' }} permissionKey={CMS}>
            <EditCms />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.FormFields}
        element={
          <PrivateRoute module={{ RegistrationField: 'R' }} permissionKey={REGISTRATION}>
            <FormFields />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.CreateBonus}
        element={
          <PrivateRoute module={{ Bonus: 'C' }} permissionKey={BONUS}>
            <CreateBonus />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.Bonus}
        element={
          <PrivateRoute module={{ Bonus: 'R' }} permissionKey={BONUS}>
            <BonusManagement />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.EditBonus}
        element={
          <PrivateRoute module={{ Bonus: 'U' }} permissionKey={BONUS}>
            <EditBonus />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.CloneBonus}
        element={
          <PrivateRoute module={{ Bonus: 'C' }} permissionKey={BONUS}>
            <CloneBonus />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.BonusDetail}
        element={
          <PrivateRoute module={{ Bonus: 'R' }} permissionKey={BONUS}>
            <BonusDetail />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.KYCLabels}
        element={
          <PrivateRoute module={{ KycLabel: 'R' }} permissionKey={KYC_SETTINGS}>
            <KYCLabels />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BannedGames}
        element={
          <PrivateRoute isWithoutHeader module={{ BannedGames: 'R' }} permissionKey={BANNED_GAMES}>
            <BannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateBannedGames}
        element={
          <PrivateRoute module={{ BannedGames: 'C' }} permissionKey={BANNED_GAMES}>
            <CreateBannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditBannedGames}
        element={
          <PrivateRoute module={{ BannedGames: 'U' }} permissionKey={BANNED_GAMES}>
            <EditBannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ClonedBannedGames}
        element={
          <PrivateRoute module={{ BannedGames: 'U' }} permissionKey={BANNED_GAMES}>
            <EditBannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AddBannedGames}
        element={
          <PrivateRoute module={{ BannedGames: 'U' }} permissionKey={BANNED_GAMES}>
            <CreateBannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AddClonedBannedGames}
        element={
          <PrivateRoute module={{ BannedGames: 'U' }} permissionKey={BANNED_GAMES}>
            <CreateBannedGames />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BannedGamesDetail}
        element={
          <PrivateRoute module={{ BannedGames: 'R' }} permissionKey={BANNED_GAMES}>
            <BannedGamesDetails isGameListing />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.WageringTemplate}
        element={
          <PrivateRoute module={{ WageringTemplate: 'R' }} permissionKey={WAGERING_TEMPLATE}>
            <WageringTemplate />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.WageringEdit}
        element={
          <PrivateRoute module={{ WageringTemplate: 'U' }} permissionKey={WAGERING_TEMPLATE}>
            <EditWageringTemplate />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.WageringDetails}
        element={
          <PrivateRoute module={{ WageringTemplate: 'R' }} permissionKey={WAGERING_TEMPLATE}>
            <WageringTeplateDetails />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateWagering}
        element={
          <PrivateRoute module={{ WageringTemplate: 'C' }} permissionKey={WAGERING_TEMPLATE}>
            <CreateWageringTemplate />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.EmailTemplate}
        element={
          <PrivateRoute module={{ EmailTemplate: 'R' }} permissionKey={EMAIL_TEMPLATE}>
            <EmailTemplate />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.EditEmailTemplate}
        element={
          <PrivateRoute module={{ EmailTemplate: 'U' }} permissionKey={EMAIL_TEMPLATE}>
            <EditEmailTemplate />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Profile}
        element={
          <PrivateRoute>
            <ProfilePage isTenant={false} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Loyalty}
        element={
          <PrivateRoute module={{ LoyaltyManagement: 'R' }} permissionKey={LOYALTY_MANAGEMENT}>
            <LoyaltyPoints />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.TenantOwnerDetail}
        element={
          <PrivateRoute permissionKey={TENANT_MANAGEMENT}>
            <OwnerDetails />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ImageGallery}
        element={
          <PrivateRoute module={{ ImageGallery: 'R' }} permissionKey={IMAGE_GALLERY}>
            <ImageGallery />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BannerManagement}
        element={
          <PrivateRoute>
            <BannerManagement module={{ BannerManagement: 'R' }} permissionKey={BANNER_MANAGEMENT} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditBanner}
        element={
          <PrivateRoute>
            <EditBanners module={{ BannerManagement: 'U' }} permissionKey={BANNER_MANAGEMENT} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ViewBanner}
        element={
          <PrivateRoute>
            <EditBanners module={{ BannerManagement: 'R' }} permissionKey={BANNER_MANAGEMENT} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateBanner}
        element={
          <PrivateRoute>
            <EditBanners module={{ BannerManagement: 'C' }} permissionKey={BANNER_MANAGEMENT} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.LanguageManagement}
        element={
          <PrivateRoute module={{ MultiLanguage: 'R' }} permissionKey={TRANSLATIONS}>
            <LanguageManagement />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditSupportLanguage}
        element={
          <PrivateRoute module={{ MultiLanguage: 'U' }} permissionKey={TRANSLATIONS}>
            <LanguageWise />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditSupportLanguageKeys}
        element={
          <PrivateRoute module={{ MultiLanguage: 'U' }} permissionKey={TRANSLATIONS}>
            <KeyWise />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AddLanguage}
        element={
          <PrivateRoute module={{ MultiLanguage: 'U' }} permissionKey={TRANSLATIONS}>
            <AddLangauge />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AddSupportLanguageKeys}
        element={
          <PrivateRoute module={{ MultiLanguage: 'U' }} permissionKey={TRANSLATIONS}>
            <AddKeys />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.PaymentAggregators}
        element={
          <PrivateRoute module={{ CashierManagement: 'R' }} permissionKey={CASHIER_METHODS}>
            <CustomPayment />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditCustomProviders}
        element={
          <PrivateRoute module={{ CashierManagement: 'U' }} permissionKey={CASHIER_METHODS}>
            <EditProvider />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ViewCustomProviders}
        element={
          <PrivateRoute module={{ CashierManagement: 'R' }} permissionKey={CASHIER_METHODS}>
            <EditProvider />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BonusReorder}
        element={
          <PrivateRoute module={{ Bonus: 'U' }} permissionKey={BONUS}>
            <ReorderBonus />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.TOManagers}
        element={
          <PrivateRoute module={{ Tenant: 'R' }} permissionKey={TENANT_MANAGEMENT}>
            <ManagersList />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ErrLanguageManagement}
        element={
          <PrivateRoute module={{ ErrorManagement: 'R' }} permissionKey={ERROR_MANAGEMENT}>
            <LanguageManagement errorCodes />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditErrSupportLanguage}
        element={
          <PrivateRoute module={{ ErrorManagement: 'U' }} permissionKey={ERROR_MANAGEMENT}>
            <LanguageWise errorCodes />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditErrSupportLanguageKeys}
        element={
          <PrivateRoute module={{ ErrorManagement: 'U' }} permissionKey={ERROR_MANAGEMENT}>
            <KeyWise errorCodes />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AddErrLanguage}
        element={
          <PrivateRoute module={{ ErrorManagement: 'U' }} permissionKey={ERROR_MANAGEMENT}>
            <AddLangauge errorCodes />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Groups}
        element={
          <PrivateRoute module={{ GroupPermission: 'R' }} permissionKey={GROUP_MANAGEMENT}>
            <GroupManagement />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateGroup}
        element={
          <PrivateRoute module={{ GroupPermission: 'C' }} permissionKey={GROUP_MANAGEMENT}>
            <CreateGroup />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditGroup}
        element={
          <PrivateRoute module={{ GroupPermission: 'U' }} permissionKey={GROUP_MANAGEMENT}>
            <CreateGroup />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ViewGroup}
        element={
          <PrivateRoute module={{ GroupPermission: 'R' }} permissionKey={GROUP_MANAGEMENT}>
            <CreateGroup viewOnly />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CashierReorder}
        element={
          <PrivateRoute module={{ CashierManagement: 'U' }} permissionKey={CASHIER_METHODS}>
            <ProviderReorder />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.Tournaments}
        element={
          <PrivateRoute module={{ Tournament: 'R' }} permissionKey={TOURNAMENT}>
            <Tournaments />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CreateTournaments}
        element={
          <PrivateRoute module={{ Tournament: 'C' }} permissionKey={TOURNAMENT}>
            <CreateTournament />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditTournaments}
        element={
          <PrivateRoute module={{ Tournament: 'U' }} permissionKey={TOURNAMENT}>
            <CreateTournament type='edit' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ViewTournament}
        element={
          <PrivateRoute module={{ Tournament: 'R' }} permissionKey={TOURNAMENT}>
            <CreateTournament type='view' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CloneTournament}
        element={
          <PrivateRoute module={{ Tournament: 'C' }} permissionKey={TOURNAMENT}>
            <CreateTournament type='clone' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.GamblingPlayerListing}
        element={
          <PrivateRoute module={{ RGFlagged: 'R' }} permissionKey={FLAGGED_PLAYERS}>
            <RGModule key='rg' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.SetThresholds}
        element={
          <PrivateRoute module={{ RGThreshold: 'U' }} permissionKey={SET_THRESHOLDS}>
            <SetRGThresholds />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.GamblingSEPlayerListing}
        element={
          <PrivateRoute module={{ RGExcluded: 'R' }} permissionKey={SELF_EXCLUDED_PLAYERS}>
            <RGModule key='rg-self' selfExcluded />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.SetAMLThresholds}
        element={
          <PrivateRoute module={{ AMLThreshold: 'U' }} permissionKey={AML_SET_THRESHOLDS}>
            <SetAMLThresholds />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AMLPlayerListing}
        element={
          <PrivateRoute module={{ AMLFlagged: 'R' }} permissionKey={AML_FLAGGED_PLAYERS}>
            <AmlPlayerListing />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.BannedPlayerSetting}
        element={
          <PrivateRoute module={{ BannedPlayer: 'R' }} permissionKey={BANNED_PLAYER_SETTING}>
            <BannedPlayerSetting isTenant={false} />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.Hub88PrepaidList}
        element={
          <PrivateRoute module={{ Bonus: 'R' }} permissionKey={BONUS}>
            <Hub88PrepaidList isTenant={false} />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CountryTranslationLangWise}
        element={
          <PrivateRoute module={{ RestrictedCountry: 'U' }} permissionKey={COUNTRIES}>
            <LanguageWise />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.CountryTranslation}
        element={
          <PrivateRoute module={{ RestrictedCountry: 'U' }} permissionKey={COUNTRIES}>
            <KeyWise />
          </PrivateRoute>
      }
      />
      <Route
        path={SuperAdminRoutes.CreateLicense}
        element={
          <PrivateRoute module={{ TenantMultiLicense: 'C' }} permissionKey={OTHER_SETTINGS}>
            <AddLicenseForm isTenant={false} title='Create' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.EditLicense}
        element={
          <PrivateRoute module={{ TenantMultiLicense: 'U' }} permissionKey={OTHER_SETTINGS}>
            <EditLicenseForm isTenant={false} title='Edit' />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.ViewLicense}
        element={
          <PrivateRoute module={{ TenantMultiLicense: 'U' }} permissionKey={OTHER_SETTINGS}>
            <EditLicenseForm isTenant={false} title='Edit' disabledField />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.HomePageUIManagement}
        element={
          <PrivateRoute module={{ HomeUIManagement: 'R' }} permissionKey={HOME_PAGE}>
            <HomePageUIConfig />
          </PrivateRoute>
      }
      />

      <Route
        path={SuperAdminRoutes.AccountPageUIManagement}
        element={
          <PrivateRoute module={{ AccountUIManagement: 'R' }} permissionKey={ACCOUNT_PAGE}>
            <AccountPageUIConfig />
          </PrivateRoute>
      }
      />
    </>
  )
}

export default SuperAdminPages
